module.exports = __webpack_public_path__ + "img/car_0000.15f82897.jpg";